import React, { useState } from 'react';
import { Play } from 'lucide-react';
import { getEmbedUrl } from '../../../lib/videoEmbed';
import type { Block } from '../../../types/parcours';

interface VideoBlock extends Block {
  type: 'video';
  url?: string;
  title?: string;
  thumbnail?: string;
}

interface Props {
  block: VideoBlock;
}

export default function VideoBlock({ block }: Props) {
  const [loaded, setLoaded] = useState(false);

  if (!block.url) return null;
  const embedUrl = getEmbedUrl(block.url);
  if (!embedUrl) return null;

  const title = block.title ?? 'Vidéo';

  return (
    <div className="my-6 rounded-xl overflow-hidden bg-neutral-100 aspect-video relative">
      {!loaded ? (
        <button
          onClick={() => setLoaded(true)}
          className="absolute inset-0 flex flex-col items-center justify-center gap-3 bg-neutral-900/60 hover:bg-neutral-900/70 transition-colors group"
          aria-label={`Lire la vidéo : ${title}`}
        >
          {block.thumbnail && (
            <img
              src={block.thumbnail}
              alt=""
              className="absolute inset-0 w-full h-full object-cover -z-0"
              loading="lazy"
              decoding="async"
            />
          )}
          <span className="relative z-10 flex items-center justify-center w-16 h-16 rounded-full bg-white/90 shadow-lg group-hover:scale-110 transition-transform">
            <Play className="w-7 h-7 text-[#d03484] fill-[#d03484] ml-1" />
          </span>
          <span className="relative z-10 text-white text-sm font-medium drop-shadow">{title}</span>
        </button>
      ) : (
        <iframe
          src={embedUrl}
          title={title}
          className="absolute inset-0 w-full h-full"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
          loading="lazy"
        />
      )}
    </div>
  );
}
